import { render, staticRenderFns } from "./Errorpage.vue?vue&type=template&id=e1a07cfc"
import script from "./Errorpage.vue?vue&type=script&lang=js"
export * from "./Errorpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports